export enum Mode {
    Read = 'Read',
    Edit = 'Edit'
}
